














import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { capitalize } from '@getaccept/lib-shared/src/helpers';
import { DashboardWidgetHeaderColor } from '../../types/enums/dashboard-widget-header-color';
import { DashboardWidgetValueColor } from '../../types/enums/dashboard-widget-value-color';
import DashboardWidget from '../DashboardWidget.vue';
import type { DashboardDealtimeData } from '../../types/dashboard-deal-time-data';

export default defineComponent({
  name: 'AverageDealTimeWidget',
  components: {
    DashboardWidget,
  },
  props: {
    dealtime: {
      type: Object as PropType<DashboardDealtimeData>,
      required: true,
    },
    dealtimeLast: {
      type: Object as PropType<DashboardDealtimeData>,
      required: true,
    },
  },
  setup(props) {
    const dealtimeValue = computed(() =>
      props.dealtime.countDays > 2 ? props.dealtime.countDays : props.dealtime.countHours
    );
    const dealtimeTitle = computed(() =>
      props.dealtime.countDays > 2
        ? t('days')
        : props.dealtime.countHours === 1
        ? t('Hour')
        : t('Hours')
    );
    const dealtimeLastValue = computed(() =>
      props.dealtimeLast.countDays > 2
        ? `${props.dealtimeLast.countDays} ${t('days')}`
        : props.dealtimeLast.countHours === 1
        ? `${props.dealtimeLast.countHours} ${t('Hour')}`
        : `${props.dealtimeLast.countHours} ${t('Hours')}`
    );

    return {
      dealtimeValue,
      dealtimeTitle,
      dealtimeLastValue,
      DashboardWidgetHeaderColor,
      DashboardWidgetValueColor,
      capitalize,
    };
  },
});
